import PropTypes from 'prop-types';
import { memo } from 'react';
import Ticket from '../../models/Ticket';
import TicketItem from '../common/TicketItem';
import { jsx as _jsx } from "react/jsx-runtime";
function TicketPanelItem(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "m-x-4",
    children: /*#__PURE__*/_jsx(TicketItem, {
      ticket: props.ticket
    })
  });
}
TicketPanelItem.propTypes = {
  ticket: PropTypes.instanceOf(Ticket).isRequired
};
export default /*#__PURE__*/memo(TicketPanelItem);